import { render } from "./Q7Detaille.vue?vue&type=template&id=4899613e&scoped=true"
import script from "./Q7Detaille.vue?vue&type=script&lang=js"
export * from "./Q7Detaille.vue?vue&type=script&lang=js"

import "./Q7Detaille.vue?vue&type=style&index=0&id=4899613e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4899613e"]])

export default __exports__